module.exports = __webpack_public_path__ + "static/morgan-015d85e2900cb22ca70ce61641454104.svg";